import React from 'react';
import { FormattedMessage } from 'react-intl';
import LocaleTooling from '../../../tooling/localeTooling';
import { intl } from '../../../locales/localesConfig';

const CalculationsUnitsHeader = props => {
  const {} = props;
  return (
    <div className="entity_header period_admin_header">
      <div className='entity_title e_2'>
        {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="periodAdmin.calculationUnitsTitle"/>)}
      </div>
    </div>
  );
};

export default CalculationsUnitsHeader;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/calculationsUnitsHeader.jsx